var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4961 14.5708H15.5061M15.8961 11.5708H16.4961C17.428 11.5708 17.8939 11.5708 18.2615 11.723C18.7515 11.926 19.1409 12.3154 19.3439 12.8054C19.4961 13.173 19.4961 13.6389 19.4961 14.5708C19.4961 15.5027 19.4961 15.9686 19.3439 16.3362C19.1409 16.8262 18.7515 17.2156 18.2615 17.4186C17.8939 17.5708 17.428 17.5708 16.4961 17.5708H4.49609C3.56421 17.5708 3.09827 17.5708 2.73073 17.4186C2.24067 17.2156 1.85132 16.8262 1.64833 16.3362C1.49609 15.9686 1.49609 15.5027 1.49609 14.5708C1.49609 13.6389 1.49609 13.173 1.64833 12.8054C1.85132 12.3154 2.24067 11.926 2.73073 11.723C3.09827 11.5708 3.56421 11.5708 4.49609 11.5708H5.09609M10.4961 12.5708V1.5708M10.4961 12.5708L7.49609 9.5708M10.4961 12.5708L13.4961 9.5708",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.aceb135064323e2c06516be534faebd4.svg";
export { ForwardRef as ReactComponent };